//subscription
import plan_reducer from "./subscription/plan/plan-reducer";
import log_reducer from "./subscription/log/log-reducer";

export default {
  //subscription
  plan: plan_reducer,
  log: log_reducer,
};
